import type { ILocTreeItem } from './types/loc'

/**
 * 外观FTO Loc API服务接口
 */
export interface LocApi {
    /**
     * 获取LOC分类树节点数据
     * @param code - LOC分类代码，为空则获取根节点
     */
    getLOCItemsData(code?: string): Promise<ILocTreeItem[]>;

    /**
     * 根据关键词搜索LOC分类树
     * @param keyword - 搜索关键词
     */
    getLOCTreeByKeyword(keyword: string): Promise<{
        query_results: Array<{
            cls_tree: ILocTreeItem;
        }>;
    }>;

    /**
     * 根据图片预测LOC分类
     * @param params - 预测参数
     * @param signal - 终止信号
     */
    predictLOC(params: { url: string }, signal?: AbortSignal): Promise<ILocTreeItem[]>;
}

/**
 * LocAPI 的 IOC 注入标识符
 */
export const LocApi = Symbol('LocApi');
